// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__1uvfD","colBig":"styles_colBig__TILEU","colSmall":"styles_colSmall__2oOak"};